import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

export default class extends BridgeComponent {
  static component = 'region-switch';
  static targets = ['options'];

  toggle(event) {
    event.preventDefault();
    this.optionsTarget.classList.toggle('d-none');
  }

  // Sends a 'requestSwitch' message to the native app via the HotwireNative bridge.
  // The native app handles switching servers, re-authenticating the user,
  // and then navigates back with a `selected_region` param that gets
  // captured as a cookie by the RegionPreference concern's before_action.
  switch(event) {
    event.preventDefault();
    const region = event.currentTarget.dataset.region;
    this.send('requestSwitch', { region });
  }
}
